/* eslint-disable vue/no-unused-properties */
import { licenseErrorCode, licenseStatesMap } from '@/const/licensePage';
import { License_Action_Activate_AsyncDocument, License_Action_Refresh_AsyncDocument, License_Action_Deactivate_AsyncDocument } from '@/graphql/codegen/generated/graphql';
import apolloClient from '@/plugins/GraphQL/Apollo/client';
import { longPolling } from '@/services/PlatfromGQL/longPolling';

export const licenseDialogMixins = {
  data() {
    return {
      licenseKey: '',
      supportMailUrl: process.env.VUE_APP_SUPPORT_MAIL,
      licensePending: false,
      timeoutHandle: undefined,
      refreshLicenseSpinner: false,
      deactivateLicenseFailed: false,
      licenseStatesMap,
    };
  },

  unmounted() {
    this.licenseKey = '';
    clearTimeout(this.timeoutHandle);
  },
  methods: {
    handleKeyPress(event) {
      if (!/^[A-Za-z0-9-]+$/.test(event.key)) {
        event.preventDefault();
      }
    },

    async submitLicense() {
      try {
        this.licensePending = true;
        const activatePollingId = await apolloClient.mutate({
          mutation: License_Action_Activate_AsyncDocument,
          variables: {
            licenseKey: this.licenseKey,
          },
        });
        const results = await longPolling.fetch('license_action_asyncResult', activatePollingId?.data?.license_action_activate_async);
        if (results?.data?.license_action_asyncResult?.result?.errorCode !== licenseErrorCode.No_Error || results?.data?.license_action_asyncResult?.result?.state === 5) {
          this.$store.commit('settings/setEnteredLicenseKeyValue', this.licenseKey);
        }
        this.licensePending = false;
        await this.$store.commit('main/dialogState', false);
        this.dialogPresets.handleLicenseStateInfo(this.openDialog, results?.data?.license_action_asyncResult?.result, this.licenseKey);
      } catch (error) {
        this.licensePending = false;
        await this.$store.commit('main/dialogState', false);
      }
    },

    async refreshLicense(isRetry, licenseKey) {
      try {
        if (isRetry) this.licensePending = true;
        else this.refreshLicenseSpinner = true;
        const refreshPollingId = await apolloClient.mutate({
          mutation: License_Action_Refresh_AsyncDocument,
        });
        const results = await longPolling.fetch('license_action_asyncResult', refreshPollingId?.data?.license_action_refresh_async);
        if (results?.data?.license_action_asyncResult?.result?.errorCode !== licenseErrorCode.No_Error || results?.data?.license_action_asyncResult?.result?.state === 5) {
          this.$store.commit('settings/setEnteredLicenseKeyValue', licenseKey);
        }
        this.timeoutHandle = setTimeout(async () => {
          if (isRetry) this.licensePending = false;
          else this.refreshLicenseSpinner = false;
          await this.$store.commit('main/dialogState', false);
          this.dialogPresets.handleLicenseStateInfo(this.openDialog, results?.data?.license_action_asyncResult?.result, licenseKey);
        }, 2000);
      } catch (error) {
        this.refreshLicenseSpinner = false;
        this.$store.commit('main/dialogState', false);
      }
    },

    async deactivateLicense(licenseKey) {
      try {
        this.licensePending = true;
        const deactivatePollingId = await apolloClient.mutate({
          mutation: License_Action_Deactivate_AsyncDocument,
          variables: {
            licenseKey: licenseKey || '',
          },
        });
        const results = await longPolling.fetch('license_action_asyncResult', deactivatePollingId?.data?.license_action_deactivate_async);
        this.licensePending = false;
        if (results?.data?.license_action_asyncResult?.result?.errorCode === 0 && results?.data?.license_action_asyncResult?.result?.state === 0) {
          await this.$router.push({ name: 'enterLicense' });
        } else {
          this.deactivateLicenseFailed = true;
        }
      } catch (error) {
        this.deactivateLicenseFailed = true;
      }
    },
  },
};
